import * as CONST from "./actionTypes";

export const categoryList = (payload, callBack) => {
  return {
    type: CONST.CATEGORY_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const categoryList_Success = (payload) => ({
  type: CONST.CATEGORY_LIST_SUCCESS,
  payload,
});

export const categoryList_Fail = (payload) => ({
  type: CONST.CATEGORY_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/
export const editCategory = (payload, callBack) => {
  return {
    type: CONST.EDIT_CATEGORY,
    payload: payload,
    callBack,
  };
};

export const editCategory_Success = (payload) => ({
  type: CONST.EDIT_CATEGORY_SUCCESS,
  payload,
});

export const editCategory_Fail = (payload) => ({
  type: CONST.EDIT_CATEGORY_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> UPDATE USER >>>>>>>>>>>>>>>*/

export const updateCategory = (payload, callBack) => {
  return {
    type: CONST.UPDATE_CATEGORY,
    payload: { ...payload },
    callBack,
  };
};

export const updateCategory_Success = (payload) => ({
  type: CONST.UPDATE_CATEGORY_SUCCESS,
  payload,
});

export const updateCategory_Fail = (payload) => ({
  type: CONST.UPDATE_CATEGORY_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD USER >>>>>>>>>>>>>>>*/

export const addCategory = (payload, callBack) => {
  return {
    type: CONST.ADD_CATEGORY,
    payload: { ...payload },
    callBack,
  };
};

export const addCategory_Success = (payload) => ({
  type: CONST.ADD_CATEGORY_SUCCESS,
  payload,
});

export const addCategory_Fail = (payload) => ({
  type: CONST.ADD_CATEGORY_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/

export const deleteCategory = (payload, callBack) => {
  return {
    type: CONST.DELETE_CATEGORY,
    payload: { ...payload },
    callBack,
  };
};

export const deleteCategory_Success = (payload) => ({
  type: CONST.DELETE_CATEGORY_SUCCESS,
  payload,
});

export const deleteCategory_Fail = (payload) => ({
  type: CONST.DELETE_CATEGORY_FAIL,
  payload,
});
